// @flow

import React from "react";
import {useFormik} from "formik";
import {useObserver} from "mobx-react-lite";
import {Input, Form, Modal} from "antd";
import {useTranslation} from "react-i18next";
import {newPasswordFormValidation} from "../../../components/newPassword/newPasswordValidation";

export const ChangePasswordModal = ({isVisible, setVisible, updateCourierPassword, title}) => {
    const {t} = useTranslation(["courierResetPasswordModal"]);
    const formik = useFormik({
        initialValues: {
            newPassword: "",
            passwordConfirm: ""
        },
        validationSchema: newPasswordFormValidation,
        onSubmit: async values => {
            await updateCourierPassword(values);
            await resetForm();
        },
        enableReinitialize: true
    });

    const {
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        isSubmitting,
        resetForm,
        setFieldValue
    } = formik;

    return useObserver(() => (
        <React.Fragment>
            <Modal
                visible={isVisible}
                centered
                title={title}
                okText={t("modal.saveButton", {ns: "common"})}
                onOk={handleSubmit}
                cancelText={t("modal.cancelButton2", {ns: "common"})}
                data-testid="courierResetPasswordUpdateModal"
                okButtonProps={{
                    "data-testid": "courierResetPasswordUpdateModal_submitButton"
                }}
                cancelButtonProps={{"data-testid": "courierResetPasswordUpdateModal_cancelButton"}}
                onCancel={() => {
                    resetForm();
                    setVisible();
                }}
            >
                <Form autoComplete="off" labelCol={{span: 24}} wrapperCol={{span: 24}}>
                    <Form.Item
                        colon={false}
                        label={t("fields.password", {ns: "common"})}
                        labelAlign="left"
                        validateStatus={
                            errors.newPassword && touched.newPassword ? "error" : "success"
                        }
                        help={errors.newPassword && touched.newPassword ? errors.newPassword : null}
                    >
                        <Input.Password
                            name="newPassword"
                            value={values.newPassword}
                            onChange={handleChange}
                            data-testid="courierChangePassword"
                        />
                    </Form.Item>
                    <Form.Item
                        colon={false}
                        label={t("fields.passwordAgain", {ns: "common"})}
                        labelAlign="left"
                        validateStatus={
                            errors.passwordConfirm && touched.passwordConfirm ? "error" : "success"
                        }
                        help={
                            errors.passwordConfirm && touched.passwordConfirm
                                ? errors.passwordConfirm
                                : null
                        }
                    >
                        <Input.Password
                            name="passwordConfirm"
                            value={values.passwordConfirm}
                            onChange={handleChange}
                            data-testid="courierNewPassword"
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    ));
};
